/* eslint-disable */
import React, { FC } from 'react';
import styles from './DonutChart.module.css';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

interface DonutChartProps {
	width?: number | string;
	height?: number | string;

	data: { name: string; value: number }[];

	colors?: string[];

	innerRadius?: number;
	outerRadius?: number;

	centerText?: string | number;

	showLegend?: boolean;

	className?: string;

	title?: string;
	subtitle?: string;
}

const DonutChart: FC<DonutChartProps> = ({
	width = '100%',
	height = 220,
	data,
	colors = ['#1ABC9C', '#2E86DE'],
	innerRadius = '50%',
	outerRadius = '95%',
	centerText,
	showLegend = true,
	className,
	title,
	subtitle,
}) => {
	return (
		<div className={`${styles.container} ${className}`} style={{ width }}>
			{/* ✅ HEADER */}
			{(title || subtitle) && (
				<div className={styles.header}>
					<div>
						{title && <div className={styles.title}>{title}</div>}
						{subtitle && (
							<div className={styles.subtitle}>{subtitle}</div>
						)}
					</div>
				</div>
			)}
			{/* Chart Section */}
			<div className={styles.bottom}>
				<div className={styles.chartWrapper} style={{ height }}>
					<ResponsiveContainer width="100%" height="100%">
						<PieChart>
							<Pie
								data={data}
								innerRadius={innerRadius}
								outerRadius={outerRadius}
								paddingAngle={0}
								dataKey="value"
								stroke="none"
							>
								{data.map((_, index) => (
									<Cell
										key={`cell-${index}`}
										fill={colors[index % colors.length]}
									/>
								))}
							</Pie>
							<Tooltip />
						</PieChart>
					</ResponsiveContainer>

					{/* Center Text */}
					{centerText && (
						<div className={styles.centerText}>{centerText}</div>
					)}
				</div>

				{/* Legend */}
				{showLegend && (
					<div className={styles.legend}>
						{data.map((item, index) => (
							<div key={index} className={styles.legendItem}>
								<span
									className={styles.dot}
									style={{
										backgroundColor:
											colors[index % colors.length],
									}}
								/>
								<span className={styles.label}>
									{item.name}
								</span>
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default DonutChart;
